<template>
  <div class="betting">
    <div class="betting_top">
      <div class="betting_top_left">
        <div class="title">{{ $t('AI智能投注') }}</div>
        <div class="sub">{{ $t('AI计划记录') }}/{{ $t('真实投注记录') }}</div>
      </div>
      <!-- <div class="betting_top_right" @click="openPop">
        <van-icon name="plus" />
        {{ $t('新计划') }}
      </div> -->
    </div>
    <div class="prediction_grid">
      <div class="grid_item app_card">
        <div class="grid_item_label">{{ $t('计划总数') }}</div>
        <div class="grid_item_money">{{ listTotal }}</div>
      </div>
      <div class="grid_item app_card">
        <div class="grid_item_label">{{ $t('进行中') }}</div>
        <div class="grid_item_money" style="color:#0A8754">{{ runNum }}</div>
      </div>
      <div class="grid_item app_card">
        <div class="grid_item_label">{{ $t('真实投注记录') }}</div>
        <div class="grid_item_money" style="color:#c48d06">{{ betNum }}</div>
      </div>
    </div>
    <template v-if="planArr?.length">
      <div class="list_plan app_card" v-for="item, index in planArr" :key="index" @click="itemClick(item)">
        <div class="plan_top">
          <div class="plan_top_left">
            <div class="_name">{{ item.title }}</div>
            <div class="_status">{{ getStatus(item.status, item.is_win) }}</div>
          </div>
          <div class="plan_top_right" v-if="item.hits_num">{{ $t('连中', { __: item.hits_num }) }}</div>
          <div class="plan_top_right" v-else-if="item.losses_num">{{ $t('连跌', { __: item.losses_num }) }}</div>
        </div>
        <div class="plan_cont">
          <div class="plan_cont_moneys">
            <div class="_item">
              <div class="_label">{{ $t('投注金额') }}</div>
              <div class="_money">{{ $money(item.cycle_betmoney || '0.00') }}</div>
            </div>
            <div class="_item">
              <div class="_label">{{ $t('奖金金额') }}</div>
              <div class="_money">{{ $money(item.cycle_winmoney || '0.00') }}</div>
            </div>
            <div class="_item">
              <div class="_label">{{ $t('累计利润') }}</div>
              <div class="_money"
                :class="Number(item?.cycle_winmoney) - Number(item?.cycle_betmoney) < 0 ? 'is_red' : 'is_green'">{{
                  $money((Number(item?.cycle_winmoney) - Number(item?.cycle_betmoney)).toFixed(2)) }}</div>
            </div>
            <div class="_item">
              <div class="_label">{{ $t('代理佣金') }}</div>
              <div class="_money is_green">{{
                $money(item.cycle_rebate || '0.00') }}</div>
            </div>
          </div>
          <div class="plan_cont_btns" v-if="item.status == 0">
            <div class="_btn" @click.stop="startOrder(item)" v-if="item.status == 0">
              {{ $t('启动') }}
            </div>
            <div class="_btn" @click.stop="cancelOrder(item)" v-else>{{ $t('My.Button.One') }}</div>
            <div class="_btn" @click.stop="editOrder(item)">{{ $t('编辑') }}</div>
            <div class="_btn" @click.stop="delOrder(item)">{{ $t('address.btn.delete') }}</div>
          </div>
          <div class="plan_cont_btns" v-if="item.status == 2">
            <div class="_btn" @click.stop="startOrder(item)">
              {{ $t('启动') }}
            </div>
          </div>
        </div>
        <div class="plan_time">
          <div class="time_title">{{ $t('label.time') }}：</div>
          <div class="_time">{{ $format(item.cycle_start_time, 'MM/dd/yyyy HH:mm') }} — {{
            $format(item.cycle_end_time, 'MM/dd/yyyy HH:mm') }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="no_data app_card" style="padding: 14px;">
        <img src="@/assets/Img/null/null.png" alt="">
        <span>{{ $t('Hint.noData') }}</span>
      </div>
    </template>
    <!-- <div class="list app_card">
      <div class="list_top">
        <div class="list_top_title">{{ $t('真实投注记录') }}</div>
        <span>{{ $t('计划数', { _num: listArr?.length }) }}</span>
      </div>
      <template v-if="listArr?.length">
        <div class="lists">
          <div class="list_item" v-for="item, index in listArr" :key="index">
            {{ item }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="no_data">
          <img src="@/assets/Img/null/null.png" alt="">
          <span>{{ $t('Hint.noData') }}</span>
        </div>
      </template>
    </div> -->
    <aiPop ref="aipopRef" :type="configs.type" @confirm="confirmChange" />
  </div>
</template>
<script>
import { Icon, Popup, Toast, Field, Checkbox, CheckboxGroup } from "vant";
import { AI_USER_PLANS, AI_PLAN_DELETE } from "@/api";
import aiPop from "./components/pop";
export default {
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    Toast,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    aiPop
  },
  props: {
    configs: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      listArr: [],
      planArr: [],
      listTotal: 0,
      runNum: 0,
      betNum: 0
    }
  },
  created() {
    this.getOrder();
  },
  methods: {
    itemClick(_item) {
      this.$router.push(`/aiDetail?id=${_item.id}`)
    },
    openPop() {
      this.$refs.aipopRef.open()
    },
    getStatus(_status, _win) {
      switch (_status) {
        case 0:
          return this.$t('计划取消');
          break;
        case 1:
          // if (Number(_win) > 0) {
          //   return this.$t('计划暂停');
          // }
          return this.$t('进行中');
          break;
        case 2:
          return this.$t('暂停');
          break;
        default:
          break;
      }
    },
    pop1ItemClick(item, index) {
      this.select1Num = index;
      this.select1open = false;
    },
    pop2ItemClick(item, index) {
      this.select2Num = index;
      this.select2open = false;
    },
    startOrder(_item) {
      this.$refs.aipopRef.arCreate({
        title: _item?.title,
        pid: _item?.pid,
        status: 1,
        steps: _item?.content,
        stop_rules: _item?.stop_rules,
        id: _item?.id,
        lottery_type: _item.last_lottery_type
      })
    },
    cancelOrder(_item) {
      this.$refs.aipopRef.arCreate({
        title: _item?.title,
        pid: _item?.pid,
        status: 0,
        steps: _item?.content,
        stop_rules: _item?.stop_rules,
        id: _item?.id,
        lottery_type: _item.last_lottery_type
      })
    },
    editOrder(_item) {
      this.$refs.aipopRef.open(_item)
    },
    async delOrder(_item) {
      Toast.loading();
      try {
        const res = await AI_PLAN_DELETE({ id: _item.id });
        Toast.clear();
        Toast(res.msg);
        setTimeout(() => {
          this.getOrder();
        }, 500)
      } catch (error) {
        Toast.clear();
        error.msg && Toast(error.msg)
      }
    },
    confirmChange() {
      this.getOrder();
    },
    async getOrder() {
      // Toast.loading();
      try {
        const { data: { lists, total, total_success_betnum } } = await AI_USER_PLANS();
        this.listTotal = total;
        this.runNum = lists.filter(item => Number(item.status) > 0).length
        Toast.clear()
        this.planArr = lists;
        this.betNum = total_success_betnum
      } catch {
        Toast.clear()
      }
    },
  }
}
</script>
<style lang="less" scoped>
.betting {
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .betting_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .betting_top_left {
      .title {
        color: var(--text-color);
        font-size: 16px;
        font-weight: 600;
      }

      .sub {
        color: #667085;
        font-size: 13px;
        margin-top: 6px;
      }
    }

    .betting_top_right {
      height: 34px;
      line-height: 34px;
      font-size: 13px;
      padding: 0 12px;
      border-radius: 999px;
      color: #1989fa;
      border: 1px solid #1989fa;
      background: var(--light);
    }
  }


  .prediction_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;

    .grid_item {
      padding: 14px 10px;
      text-align: center;
      display: flex;
      flex-direction: column;

      .grid_item_label {
        text-align: center;
        font-size: 13px;
        color: #7b808d;
      }

      .grid_item_money {
        text-align: center;
        font-size: 15px;
        color: #111827;
        font-weight: 600;
        margin-top: 8px;
      }
    }
  }

  .list_plan {
    padding: 16px;

    .plan_top {
      display: flex;
      justify-content: space-between;
      gap: 12px;

      .plan_top_left {
        font-weight: 600;

        ._name {
          color: #111827;
          font-size: 16px;
        }

        ._status {
          color: #0a8754;
          font-size: 15px;
          margin-top: 5px;
        }
      }

      .plan_top_right {
        color: #ff5f59;
        font-size: 16px;
        font-weight: 600;
      }
    }

    .plan_cont {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      gap: 12px;

      .plan_cont_moneys {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 10px;

        ._item {
          display: flex;
          align-items: center;
          justify-content: space-between;

          ._label {
            color: #667085;
            font-size: 13px;
          }

          ._money {
            color: #111827;
            font-size: 16px;
          }

          .green {
            color: #0a8754;
          }
        }
      }

      .plan_cont_btns {
        display: flex;
        flex-direction: column;
        gap: 12px;

        ._btn {
          padding: 0 20px;
          height: 40px;
          border-radius: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--light);
          background: #1989fa;
          line-height: 1;
          font-size: 14px;
        }
      }
    }

    .plan_time {
      margin-top: 10px;
      display: flex;
      align-items: baseline;

      .time_title,
      ._time {
        color: #667085;
        font-size: 13px;
      }

      ._time {
        color: #0f172a;
        font-weight: 600;
        line-height: 1;
      }
    }
  }

  .list {
    padding: 12px;

    .list_top {
      .list_top_title {
        font-size: 18px;
        font-weight: 900;
        color: var(--theme);
      }

      span {
        color: #667085;
        margin-top: 6px;
        font-size: 13px;
      }
    }

    .lists {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .list_item {
        padding: 14px;
        border-radius: 18px;
        border: 1px solid rgba(15, 23, 42, .06);
        background: #fff;
        box-shadow: 0 10px 20px #0f172a0a;
        cursor: pointer;
        transition: transform .18s ease, box-shadow .18s ease;
      }
    }
  }

  .no_data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;

    img {
      width: 160px;
      height: 160px;
      display: block;
    }

    span {
      color: #969799;
      font-size: 14px;
    }
  }

  .is_red {
    color: #e84f62 !important;
  }

  .is_green {
    color: #0cc183 !important;
  }
}
</style>